/**
 * Hier kommt übergreifender Code für folgende Mitarbeiterstammdaten hin
 * - Personalien
 * - Beschaeftigung
 * - Abgaben
 * - Lohnarten & Nettobezüge
 * - Zuschläge
 * - Historie
 */

import _ from 'underscore';
import dayjs from '../../../../shared/services/dayjs.js';
import stammdatenService from '../services/stammdatenService.js';
import {
    debounce,
    erstelleMitarbeiterListe,
    resetValidationMessages,
} from '../util.js';
import basedataService from '../services/basedataService.js';

const debounceSpeichereMA = debounce(async (args) => {
    const maToSave = args[0];
    // Validierung: speichere nur, wenn es noch der gleiche MA ist (verhindert Race Conditions bei schnellem Wechsel)
    if (maToSave._id !== stammdatenService.aktuellerMitarbeiter._id) {
        return;
    }
    checkElterneigenschaft(stammdatenService.aktuellerMitarbeiter);
    await stammdatenService.updateMitarbeiterdaten(maToSave);
    // validierung entsprechend des Mitarbeiter Reiters
    switch (window.myVars.websiteStatus) {
        case 'ma-personalien':
            validatePersonalien(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-beschaeftigung':
            validateBeschaeftigung(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-zuschlaege':
            validateZuschlaege(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-abgaben':
            validateAbgaben(stammdatenService.aktuellerMitarbeiter);
            break;
        case 'ma-zeitkonto':
            validateZeitkonto(stammdatenService.aktuellerMitarbeiter);
            break;
        default:
            break;
    }
    aktualisiereFristen(stammdatenService.aktuellerMitarbeiter);
    await erstelleMitarbeiterListe(stammdatenService.aktuelleBetriebsstaette);
}, 1000);

/**
 * Speichert die aktuellen Mitarbeiterdaten, falls es eine Änderung gibt.
 */
async function forceUpdateMA() {
	// Falls es Änderungen im Mitarbeiter Objekt gibt, müssen wir erst speichern und den debounce entfernen...
	if (window.myVars.mitarbeiterEditiert && !_.isEmpty(stammdatenService.aktuellerMitarbeiter)) {
		await stammdatenService.updateMitarbeiterdaten(stammdatenService.aktuellerMitarbeiter);
		clearTimeout(window.myVars.lastDebounceId);
	}
}

function validateZeitkonto(aktuellerMA) {
    resetValidationMessages();
    const htmlParent = document.getElementById('ma-Zeitkonto');
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlParent.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
}

function validateAbgaben(aktuellerMA) {
    resetValidationMessages();
    const htmlParent = document.getElementById('ma-Abgaben');
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlParent.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText += error.message + '\n';
        }
    });
    const besch = aktuellerMA.Beschaeftigung[0];
    htmlParent.querySelector('#empty-rvNr').style.display = besch.Sozialversicherung.Rentenversicherungsnummer === '' ? 'flex' : 'none';
    htmlParent.querySelector('#empty-steuerID').style.display = besch.Steuer.SteuerIdentifikationsnummer === '' ? 'flex' : 'none';
}


function validatePersonalien(aktuellerMA) {
    const htmlDiv = document.getElementById('ma-Personalien');
    resetValidationMessages();
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlDiv.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
    htmlDiv.querySelector('#empty-geburtsort').style.display = aktuellerMA.Personalien.Geburtsort === '' ? 'flex' : 'none';
}

function validateBeschaeftigung(aktuellerMA) {
    resetValidationMessages();
    const htmlParent = document.getElementById('ma-Beschaeftigung');
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        // Für die Regelarbeitszeiten müssen wir 2x7 messages zeigen...
        if (error?.instancePath?.includes('Regelarbeitszeiten')) {
            const htmlElement = htmlParent.querySelector('[aria-label="/Beschaeftigung/0/Regelarbeitszeiten"]');
            htmlElement.innerText = error.message;
            return;
        }
        // Chef vom Dienst braucht hier keine Fehlermeldung
        if (error?.instancePath?.includes('Verguetung/') && !window.myVars.HideMod) {
            const htmlElement = htmlParent.querySelector(`[aria-label="/Beschaeftigung/0/Verguetung/__index__/${error.instancePath.split('/')[5]}"]`);
            if (htmlElement) {
                htmlElement.innerText = error.message;
                return;
            }
        }
        const htmlElement = htmlParent.querySelector(`[aria-label="${error.instancePath}"]`);
        if (error.message.includes('Qualifikation nicht vorhanden')) {
            htmlElement.innerHTML = `
            ${error.message}&nbsp;
            <a href="https://handbuch.neolohn.de/link/355#bkmrk-2.-%E2%80%9Equalifikation-ni" target="_blank" title="Öffne Hilfe im Handbuch">
                <i class="bi bi-info-circle"></i>
            </a>`;
            return;
        }
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
}

function validateZuschlaege(aktuellerMA) {
    const htmlDiv = document.getElementById('ma-Zuschlaege');
    resetValidationMessages();
    const validateResults = aktuellerMA.Errors;
    validateResults.forEach((error) => {
        const htmlElement = htmlDiv.querySelector(`[aria-label="${error.instancePath}"]`);
        if (htmlElement) {
            htmlElement.innerText = error.message;
        }
    });
}

function checkElterneigenschaft(mitarbeiter) {
    // automatisch aktiv, falls MA Kinder hat oder Kinderfreibetrag
    const maHatKinder = mitarbeiter.Beschaeftigung[0].Sozialversicherung.AnzahlKinder > 0 || mitarbeiter.Beschaeftigung[0].Steuer.Kinderfreibetrag > 0 || mitarbeiter.Beschaeftigung[0].Sozialversicherung.GeburtstageKinder.length > 0;
    // Elterneigenschaft automatisch auf true setzen falls Kinder vorhanden, aber nicht automatisch auf false
    if (maHatKinder) {
        mitarbeiter.Beschaeftigung[0].Sozialversicherung.Elterneigenschaft = maHatKinder;
    }
    // Wenn MA Kinder hat bzw Elterneigenschaft aktiv oder jünger als 23 ist, dann zahlt er keinen PV Zusatz
    // ohne Geburtsdatum kann das Alter nicht bestimmt werden, dann bleibt der gespeicherte Wert unverändert
    const geburtsdatum = mitarbeiter.Personalien.Geburtsdatum ? dayjs.tz(mitarbeiter.Personalien.Geburtsdatum, dayjs.tz.DEFAULT_TZ) : null;
    if (geburtsdatum?.isValid()) {
        const zeitraum = window.myVars.aktuellesMonatsDatum;
        const mitarbeiterAlter = zeitraum.diff(geburtsdatum, 'year');
        // ... umgekehrt heißt dass, wenn der Mitarbeiter keine Elterneigenschaft und 23 oder älter ist, dann zahlt er den PV Zusatz
        mitarbeiter.Beschaeftigung[0].Sozialversicherung.PflegeversicherungsZusatz = !mitarbeiter.Beschaeftigung[0].Sozialversicherung.Elterneigenschaft && mitarbeiterAlter >= 23;
    }
    const elternCheck = document.body.querySelector('[aria-label="ma-Elterneigenschaft"]');
    if (elternCheck) {
        elternCheck.checked = mitarbeiter.Beschaeftigung[0].Sozialversicherung.Elterneigenschaft;
    }
    const pvZusatzCheck = document.body.querySelector('[aria-label="ma-PflegeversicherungsZusatz"]');
    if (pvZusatzCheck) {
        pvZusatzCheck.checked = mitarbeiter.Beschaeftigung[0].Sozialversicherung.PflegeversicherungsZusatz;
    }
}

/**
 * Ermittelt die optionalen Fristen, die für die Dokumentenakte des Mitarbeiters trotzdem notwendig sind.
 * - Nicht-EU-Bürger: Arbeitserlaubnis + Aufenthaltsgenehmigung
 * - Studenten (PGS 106): Immatrikulationsbescheinigung
 * @param {object} mitarbeiter
 * @returns {Promise<string[]>} Attributnamen der notwendigen Fristen in Beschaeftigung[0]
 */
async function ermittleNotwendigeFristen(mitarbeiter) {
    const notwendigeFristen = [];
    const nationenschluessel = mitarbeiter.Personalien.Staatsangehoerigkeit?.Nationenschluessel;
    if (nationenschluessel) {
        const laender = await basedataService.holeLaenderBasedataProvider();
        const isEUMitglied = laender.some((land) => land.EgMitglied == '1' && land.Nationenschluessel == nationenschluessel);
        if (!isEUMitglied) {
            notwendigeFristen.push('ArbeitserlaubnisBis', 'AufenthaltsgenehmigungBis');
        }
    }
    if (mitarbeiter.Beschaeftigung[0].Personengruppenschluessel == '106') {
        notwendigeFristen.push('Immatrikulationsbescheinigung');
    }
    return notwendigeFristen;
}

/**
 * Hebt die notwendigen Fristen in der Beschäftigung farblich hervor, fehlende oder abgelaufene zusätzlich orange.
 * Ist die Beschäftigung nicht geöffnet, passiert nichts.
 * @param {object} mitarbeiter
 */
async function markiereNotwendigeFristen(mitarbeiter) {
    const htmlParent = document.getElementById('ma-Beschaeftigung');
    if (!htmlParent) return;
    const notwendigeFristen = await ermittleNotwendigeFristen(mitarbeiter);
    const heute = dayjs.tz(new Date(), 'Europe/Berlin').format('YYYY-MM-DD');
    ['ArbeitserlaubnisBis', 'AufenthaltsgenehmigungBis', 'Immatrikulationsbescheinigung'].forEach((frist) => {
        const input = htmlParent.querySelector(`[aria-label="ma-${frist}"]`);
        if (!input) return;
        const notwendig = notwendigeFristen.includes(frist);
        const fristDatum = mitarbeiter.Beschaeftigung[0][frist];
        input.classList.toggle('important-input', notwendig);
        input.classList.toggle('frist-fehlt', notwendig && (!fristDatum || fristDatum < heute));
    });
}

/**
 * Prüft die Fristen im neoChecker neu und aktualisiert die Hervorhebung,
 * z.B. nachdem sich Staatsangehörigkeit, PGS oder Fristen geändert haben.
 * @param {object} mitarbeiter
 */
function aktualisiereFristen(mitarbeiter) {
    const neochecker = window.myServices?.neoChecker;
    if (neochecker) {
        neochecker.hideMessages();
        neocheckerMitarbeiterFristen(neochecker, mitarbeiter);
    }
    markiereNotwendigeFristen(mitarbeiter);
}

/**
 * Zeigt Fristen an und wie viele Tage noch fehlen. 
 * 
 * Hier kann die Zeitzone außer Betracht gezogen werden, da wir nur Differenzen vergleichen.
 * 
 * @param {*} neochecker 
 * @param {*} mitarbeiter 
 * @returns 
 */
async function neocheckerMitarbeiterFristen(neochecker, mitarbeiter) {
    if (!neochecker || !mitarbeiter) return;
    const heute = dayjs().startOf('day');
    // kein Check wenn MA schon ausgetreten ist.
    const austrittMA = mitarbeiter.Beschaeftigung[0].Austrittsdatum ? dayjs(mitarbeiter.Beschaeftigung[0].Austrittsdatum) : '';
    if (austrittMA && heute.isAfter(austrittMA)) return;
    const notwendigeFristen = await ermittleNotwendigeFristen(mitarbeiter);
    // Check Aufenthalt + Arbeitsgenehmigung
    if (notwendigeFristen.includes('ArbeitserlaubnisBis')) {
        const aufenthaltFrist = dayjs(mitarbeiter.Beschaeftigung[0].AufenthaltsgenehmigungBis); 
        const arbeitserlaubnisFrist = dayjs(mitarbeiter.Beschaeftigung[0].ArbeitserlaubnisBis); 
        // Wenn keine First eingegeben -99999, sonst die Differenz zum heutigen Tag...
        const aufenthaltDiff = aufenthaltFrist.isValid() ? heute.diff(aufenthaltFrist, 'days') * -1 : -99999999;
        const arbeitserlaubnisDiff = arbeitserlaubnisFrist.isValid() ? heute.diff(arbeitserlaubnisFrist, 'days') * -1 : -99999999;
        const aufenthaltNachAustritt = aufenthaltFrist.isValid() && austrittMA ? aufenthaltFrist.isSameOrAfter(austrittMA) : false;
        const arbeitserlaubnisNachAustritt = arbeitserlaubnisFrist.isValid() && austrittMA ? arbeitserlaubnisFrist.isSameOrAfter(austrittMA) : false;
        if (!aufenthaltNachAustritt && aufenthaltDiff < 0) {
            neochecker.showMessage('Aufenthaltsgenehmigung abgelaufen / fehlt!', 'error');
        }
        if (!arbeitserlaubnisNachAustritt && arbeitserlaubnisDiff < 0) {
            neochecker.showMessage('Arbeitserlaubnis abgelaufen / fehlt!', 'error');
        }
        if (!aufenthaltNachAustritt && aufenthaltDiff >= 0 && aufenthaltDiff <= 90) {
            neochecker.showMessage(`Aufenthaltsgenehmigung läuft in ${aufenthaltDiff} Tagen aus!`, 'warning');
        }
        if (!arbeitserlaubnisNachAustritt && arbeitserlaubnisDiff >= 0 && arbeitserlaubnisDiff <= 90) {
            neochecker.showMessage(`Arbeitserlaubnis läuft in ${arbeitserlaubnisDiff} Tagen aus!`, 'warning');
        }
    }
    // Check Student Immatrikulationsbescheinigung
    if (notwendigeFristen.includes('Immatrikulationsbescheinigung')) {
        const immatrikulationFrist = dayjs(mitarbeiter.Beschaeftigung[0].Immatrikulationsbescheinigung);
        // Wenn keine First eingegeben -99999, sonst die Differenz zum heutigen Tag...
        const immatrikulationDiff = immatrikulationFrist.isValid() ? heute.diff(immatrikulationFrist, 'days') * -1 : -99999999;
        const immatrikulationNachAustritt = immatrikulationFrist.isValid() && austrittMA ? immatrikulationFrist.isSameOrAfter(austrittMA) : false;
        if (!immatrikulationNachAustritt && immatrikulationDiff < 0) {
            neochecker.showMessage('Immatrikulationsbescheinigung abgelaufen / fehlt!', 'error');
        }
        if (!immatrikulationNachAustritt && immatrikulationDiff >= 0 && immatrikulationDiff <= 90) {
            neochecker.showMessage(`Immatrikulationsbescheinigung läuft in ${immatrikulationDiff} Tagen aus!`, 'warning');
        }
    }
    // Check befristeter SB-Ausweis
    if (mitarbeiter.Beschaeftigung[0].SBAusweis === 'befristet') {
        const sbAusweisFrist = dayjs(mitarbeiter.Beschaeftigung[0].SBAusweisBis);
        // Wenn keine First eingegeben -99999, sonst die Differenz zum heutigen Tag...
        const sbAusweisDiff = sbAusweisFrist.isValid() ? heute.diff(sbAusweisFrist, 'days') * -1 : -99999999;
        const sbAusweisNachAustritt = sbAusweisFrist.isValid() && austrittMA ? sbAusweisFrist.isSameOrAfter(austrittMA) : false;
        if (!sbAusweisNachAustritt && sbAusweisDiff < 0) {
            neochecker.showMessage('SB-Ausweis abgelaufen / fehlt!', 'error');
        }
        if (!sbAusweisNachAustritt && sbAusweisDiff >= 0 && sbAusweisDiff <= 90) {
            neochecker.showMessage(`SB-Ausweis läuft in ${sbAusweisDiff} Tagen aus!`, 'warning');
        }
    }
    const beschaeftigung = mitarbeiter.Beschaeftigung[0];
    // Check Befristung (kein Pflichtfeld, daher keine "fehlt"-Meldung)
    const befristungFrist = beschaeftigung.BefristetBis ? dayjs(beschaeftigung.BefristetBis) : null;
    if (befristungFrist?.isValid()) {
        const befristungDiff = heute.diff(befristungFrist, 'days') * -1;
        const befristungNachAustritt = austrittMA ? befristungFrist.isSameOrAfter(austrittMA) : false;
        if (!befristungNachAustritt && befristungDiff < 0) {
            neochecker.showMessage('Befristung abgelaufen!', 'error');
        }
        if (!befristungNachAustritt && befristungDiff >= 0 && befristungDiff <= 90) {
            neochecker.showMessage(`Befristung läuft in ${befristungDiff} Tagen aus!`, 'warning');
        }
    }
    // Check Steuer-ID (nicht notwendig ohne LSt-Karte oder bei freien Mitarbeitern)
    const steuerIDNotwendig = beschaeftigung.Steuer.Steuerberechnung != 2 && beschaeftigung.Personengruppenschluessel !== '909';
    if (steuerIDNotwendig && !beschaeftigung.Steuer.SteuerIdentifikationsnummer) {
        neochecker.showMessage('Steuer-ID fehlt!', 'error');
    }
    // Check Rentenversicherungsnummer (Todo, wird mitgezählt)
    if (!beschaeftigung.Sozialversicherung.Rentenversicherungsnummer) {
        neochecker.showMessage('Rentenversicherungsnummer fehlt!', 'warning', true);
    }

}

export {
    forceUpdateMA,
    debounceSpeichereMA,
    validatePersonalien,
    validateBeschaeftigung,
    validateZeitkonto,
    validateAbgaben,
    validateZuschlaege,
    neocheckerMitarbeiterFristen,
    markiereNotwendigeFristen,
    aktualisiereFristen
};
